/**
 * Extend Marb namespace
 */
try {
	Marb.extend({
		Job : (function() {
			var cancelJob = function(jobId) {
				var defaultReason = cancelReasons.shift();
				var bodyHtml = '<div> \
									<div>' + $.i18n.prop('p.jobheader.cancel.body') + '</div> \
									<div> \
										<br /> \
										<label>'+ $.i18n.prop('p.jobheader.cancel.why') +'</label> \
										<select id="cancelReasonSelect"> \
											<option value="">' + defaultReason + '</option> \
											{{#.}}<option>{{.}}</option>{{/.}} \
										</select> \
									</div> \
								</div>';
				Marb.Components.Confirm.openSimple({
					title: $.i18n.prop('p.jobheader.cancel.title'),
					bodyHtml: Mustache.render(bodyHtml, cancelReasons),
					accept: function(popup){
						Marb.Components.Confirm.loading(popup);
						var cancelReason = $('#cancelReasonSelect').val();
						var form = $("<form action='/secure/customer/job/"+jobId+"/cancel' method='POST'>" +
										"<input type='hidden' name='cancelReason' value='" + cancelReason + "' />" +
									"</form>");
						$(form).appendTo('body').submit();

						return true;
					}
				});
			};

			var acceptQuote = function(formId, quoteId){
				$('#'+formId).attr('action', '/secure/customer/job/quote/' + quoteId + '/accept');
				$('#'+formId).submit();
			};

			var cancelQuote = function(quoteId, callback) {
				$.post('/secure/quote/'+quoteId+'/cancel', function(data){
					if( callback ){
						callback(data);
					}
				});
			};

			var acceptQuoteVisit = function(formId, quoteId, callback){
				$.post('/secure/customer/job/quote/' + quoteId + '/onsite',
					$('#'+formId).serialize(),
					function(data){
						if( callback ){
						callback(data);
						}
					}
				);
			};

			var rateValue = function(field, label, error, initValue){
				var starRating = $(
				 '<div class="star-rating" data-value="' + initValue + '">\
						<div class="starOff star-1" data-value="1"></div>\
						<div class="starOff star-2" data-value="2"></div>\
						<div class="starOff star-3" data-value="3"></div>\
						<div class="starOff star-4" data-value="4"></div>\
						<div class="starOff star-5" data-value="5"></div>\
				  </div>');
				if( initValue && initValue > 0 && initValue < 6 ){
					starRating.addClass('stars-' + initValue);
					$(label).val(initValue);
				}
				starRating.children('.starOff').on({
					mouseenter: function(){
						$(this).closest('.star-rating').addClass('stars-' + $(this).data('value'));
					},
					mouseleave: function(){
						$(this).closest('.star-rating').removeClass('stars-' + $(this).data('value'));
					},
					click: function(){
						var value = $(this).data('value');
						var container = $(this).closest('.star-rating');
						container.data('value', value);
						container.addClass('stars-'+value);
						$(label).val(value);
						$(error).hide();
					}
				});
				starRating.on({
					mouseenter: function(){
						var value = $(this).data('value');
						if( value ){
							$(this).removeClass('stars-' + value);
						}
					},
					mouseleave: function(){
						var value = $(this).data('value');
						if( value ){
							$(this).attr('class','star-rating stars-' + value);
						}
					}
				});
				$(field).append(starRating);
			};

			var rateValueValidate = function(field){
				var valueId = '#value-for-' + field;
				var errorId = '#error-for-' + field;
				var value = $(valueId).val();
				if( value < 1 || value > 5){
					$(errorId).show();
					return true;
				}
				return false;
			};

			var rateJob = function(data){
				var jobId = data.jobId;
				var rateStatus = data.rateStatus;
				Marb.Components.Confirm.open({
					url: '/secure/customer/job/'+jobId+'/rate/'+rateStatus
				});
				
			};

			var viewJobRating = function(jobId, customerId, data){
				var url = '/secure/job/' + jobId + '/view-rating/' + customerId;
				Marb.Commons.Utils.popup({url: url});
			};
			
			var viewJobDetails = function(jobId,customerId, data){
				location.href="/secure/company/job/"+jobId;
			}
			
			
			var markJobFinished = function(data) {
				var jobId = data.jobId;
				var quoteId = data.quoteId;
				var price = data.price;
				Marb.Components.Confirm.open({id: 'quote-mark-finished-popup',
	  				accept: function(confirmPopup){ 
	  					 if (!validatePrice()){
	  						 return true;
	  					 } else {
	  						var price = $('#job-price').val();
		  					 $.ajax({url: '/secure/company/job/'+jobId+'/quote/'+quoteId+'/mark-finished',				
		  						type: 'POST',
		  						data: {"jobPrice": price},		
		  						success: function() {
		  							Marb.Page.Toast.success({text: $.i18n.prop('p.toast.markedFinished.success')});	
		  							var delay=1000; 						
									setTimeout(function(){							
										location.href = "/secure/dashboard";
									}, delay); 
		  						},
		  						error: function(){
		  							Marb.Page.Toast.error({text: $.i18n.prop('p.toast.markedFinished.error')});
		  							var delay=1000; 						
									setTimeout(function(){							
										location.href = "/secure/dashboard";
									}, delay); 
		  						}
		  					 });	
	  					 }
	  					return true;
	  				}
	  			});				
			}

            var markToBeRescheduled = function (jobId) {

            }
			
			var filterDashboard = function(settings){
				var itemsSelector = settings.itemsSelector;
				var filterCallback = settings.filterCallback;
				
				if (settings.currentTab == 'QR'){
					$.each($(itemsSelector), filterCallback);
				}
			}
			

			var JobWizard = function(data) {
				var data = data || {};
				var registerContainerId = "#" + (data.registerContainerId ? data.registerContainerId : "register-container");
				var loginContainerId = "#" + (data.loginContainerId ? data.loginContainerId : "login-container");
				var alreadyUserContainerId = "#" + (data.alreadyUserContainerId ? data.alreadyUserContainerId : "already-user-container");
				var signupId = "#" + (data.signupId ? data.signupId : "sign-up");
				var metadataStringyId = "#" + (data.metadataStringyId ? data.metadataStringyId : "metadata");
				var mainFormId = "#" + (data.mainFormId ? data.mainFormId : "create-job-form");
				var metadataFormId = "#" + (data.metadataFormId ? data.metadataFormId : "metadata-form");
				var categoryCombo = (data.categoryComboId ? data.categoryComboId : "categoryId");
				var categoryComboId = "#" + categoryCombo;
				var subcategoryCombo = (data.subCategoryComboId ? data.subCategoryComboId : "subCategoryId");
				var subCategoryComboId = "#" + subcategoryCombo;
				var descriptionId = "#" + (data.descriptionId ? data.descriptionId : "description");
				var stepIdPrefix = "#" + (data.stepIdPrefix ? data.stepIdPrefix : "job-step-");
				var metadataContent = "#" + (data.metadataContent ? data.metadataContent : "metadata-content");
				var snapshotStepId = "#" + (data.step1Id ? data.step1Id : "step");
				var prevStepClass =  (data.prevStepClass ? data.prevStepClass : "prevstep");
				var nextStepClass = (data.nextStepClass ? data.nextStepClass : "nextstep");
				var isLoggedId = "#" + (data.isLoggedId ? data.isLoggedId : "isLogged");
				var submitJobId = "#" + (data.submitJobId ? data.submitJobId : "submit-job");
				var stepId = "#" + (data.stepId ? data.stepId : "step");
				var redirectUrl = "/secure/dashboard";
				var invalidLoginContainerId = "#" + (data.invalidLoginContainerId ? data.invalidLoginContainerId : "invalid-login-container-id");
				var unexpectedErrorContainerId = "#" + (data.unexpectedErrorContainerId ? data.unexpectedErrorContainerId : "unexpected-error-container-id");
				var workInProgress = data.workInProgress ? data.workInProgress : false;
				var fromCompanyReferrer = data.fromCompanyReferrer ? data.fromCompanyReferrer : false;
				var validateAutocomplete = true;
				var condensedFlow = data.condensedFlow || false;
				var cityCompleteWatermark = data.cityCompleteWatermark || '';
				var suggestedProductCallback = data.suggestedProductCallback || null;
				if( data.validateAutocomplete != undefined ){
					validateAutocomplete = data.validateAutocomplete;
				}

				var checkClassifiedsInLocation = function(cb) {
					$.get('/check/classifieds-in-location',
						{
							c: $('#subCategoryId').val(),
							loc: $('#city').val()
						},
						function(data){
							if(data.success == true && data.data.count == 0) {
								Marb.Components.Confirm.openSimple({
									title: $.i18n.prop('p.createjob.dialog.noclassified.title'),
									bodyHtml: $.i18n.prop('p.createjob.dialog.noclassified.desc'),
									showCancel: false
								});
							} else {
								if(cb) {
									cb();
								}
							}
						}
					);
				}

				this.init = function() {

					$(jQuery.i18n).ready(function(){
						var placeholderDescr = $(this).find(':selected').data('holderdescr');
		        		if(placeholderDescr == null){
		        			placeholderDescr = $.i18n.prop('p.createjob.description.watermark')
		        		}
		        		$(descriptionId).watermark(placeholderDescr);					});

					$(alreadyUserContainerId).click(function(){
						takeSnapshot();
						$(registerContainerId).hide();
						$(loginContainerId).show();
					});

					$('#create-job-container .sign-up').click(function(){
						takeSnapshot();
						$(loginContainerId).hide();
						$(registerContainerId).show();
					});

					Marb.Category.loadCombo(categoryCombo, subcategoryCombo);

					$(subCategoryComboId).change(function(){
			        	if($(subCategoryComboId).val() == "") {
			        		$(metadataStringyId).val("");
			        	} else {
			        		loadMetadata();
			        		var placeholderDescr = $(this).find(':selected').data('holderdescr');
			        		if(placeholderDescr == null){
			        			placeholderDescr = $.i18n.prop('p.createjob.description.watermark')
			        		}
			        		$(descriptionId).watermark(placeholderDescr);
			        	}
			        });

					$("#create-job-container").on("click", "." + prevStepClass ,function(){
			        	var prevstep = $(this).data("prevstep");
			        	var curr = prevstep + 1;
			        	showSteps[prevstep-1]();
			        });

					$("#create-job-container").on("click", "." + nextStepClass, function(){

			        	var nextstep = $(this).data("nextstep");
			        	var curr = nextstep - 1;
			        	var goToNextStep = function() {
			        		showSteps[curr]();
							$(stepId).val(nextstep);
							takeSnapshot();
			        	}

			        	if(validators[curr - 1]()) {
			        		if(curr == 2) {
				        		checkClassifiedsInLocation(goToNextStep);
			        		} else {
			        			goToNextStep();
			        		}
			        	}

			        });

					//TimeFrame selection
					$(mainFormId + ' #job-step-2 [name=timeFrame]').on('click', function(){
						if( $(this).val() != 'SPECIFIC' ){
							$(mainFormId + ' #job-step-2 #when').prop('disabled', true);
							$(mainFormId + ' #job-step-2 #whenTime').prop('disabled', true);
						}else{
							var when = $(mainFormId + ' #job-step-2 #when');
							when.removeClass('error');
							when.prop('disabled', false);
							$(mainFormId + ' #job-step-2 #whenTime').prop('disabled', false);
						}
					});
					$(mainFormId + " #job-step-2 #when").datepicker({
		        		buttonImage: "/static/images/ico_calendar.png",
		        	    buttonImageOnly: true,
		        	    dateFormat: "dd/mm/yy",
		        	    minDate: 0
		        	});
					$(mainFormId + ' #job-step-2 #when,'+
					  mainFormId + ' .calendar-img').click(function(){
						$(mainFormId + ' #job-step-2 #timeFrame-SPECIFIC').click();
						$(mainFormId + ' #job-step-2 #when').datepicker( "show" );
					});

					$(mainFormId + " :input").change(function(){
			        	$(mainFormId).validate().element($(this));
			        });

					Marb.Geo.setCityAutocomplete({
						textId: 'city-search-text',
						valueId: 'city',
						// filter: 'leaf',
						textWatermark: cityCompleteWatermark
					});

					$(".login-btn").click(function(){
						if(validateLogin()) {
							var username = $("#j_username").val();
			        		var password = $("#j_password").val();
			        		var logged = M.Commons.Utils.login(username, password);
			        		if(logged) {
			        			$(loginContainerId).hide();
								$(invalidLoginContainerId).hide();
								
								doSubmitForm();
			        		}
			        		else {
			        			$(invalidLoginContainerId).show();
			        			return;
			        		}
		        		}
					});

					$(".register-btn").click(function(){
						if(validators[validators.length - 1]() && validateRegistration()){
							$("#registration-form-container").hide();
							$(mainFormId).append($("#registration-form-container"));
							doSubmitForm();
						}
					});

					$(submitJobId).click(function(){
						if(condensedFlow){
							if(!validateCondensed()) {
								return ;
							}
						} else if(!validators[validators.length - 1]()) {
							return ;
						}
						
						doSubmitForm();
			        });

					$('#create-job-container #login-btn').on('click', function(){
						$('#create-job-container .show-login').hide();
						$('#create-job-container .show-registration').show();
						$('#create-job-container #registration-form').hide();
						$('#create-job-container #login-form').show();
					});
					$('#create-job-container #create-user-btn').on('click', function(){
						$('#create-job-container .show-login').show();
						$('#create-job-container .show-registration').hide();
						$('#create-job-container #registration-form').show();
						$('#create-job-container #login-form').hide();
					});

					if( $(isLoggedId).val() == 'true' ){
						$("#job-tab-3").hide();
					}

					$(".fbsignin").click(function(){
						$.modal.close();
						Marb.Loader.block();
						takeSnapshot(function() {
							var redirectUrl = window.location.pathname;
							var form = $('<form action="/signin/facebook?fbRedirectUrl='+redirectUrl+'" method="POST"><input type="hidden" name="scope" value="email" /></form>');
				    		$("body").append(form);
				    		$(form).submit();
			    		});
					});

					function validateCondensed() {
						var valid = true;

						$(':input', '#create-job-form').filter(":visible").each(function(index,value){
			        		var elvalid = $(mainFormId).validate().element($(value));
			        		valid &= elvalid;
			        		if(!elvalid){
		        				value.focus();
		        			}
			        	});

						return valid;
					}

					function validateStep1() {
			        	var valid = true;
			        	$(stepIdPrefix + '1 :input').each(function(index,value){
			        		var type = $(value).attr('type');
			        		if(type != 'button' && type != 'submit' ) {
			        			var elvalid = $(value.form).validate().element($(value));
			        			valid &= elvalid;
			        			if(!elvalid){
			        				value.focus();
			        			}
			        		}
			        	});
			        	
			        	return valid;
			        }

					function populateMetadata(){
						var mdata = $(metadataStringyId).val();
						if(mdata.length > 0) {
							$(mainFormId).deserialize(mdata);

						}
					}

					function loadMetadata() {
						$(metadataContent).load("/category/metadata/" + $(subCategoryComboId).val(),function() {
							arrangeMetadataStyles();
			    			populateMetadata();
						});
					}

					function arrangeMetadataStyles(){
						if( $(window).width() < 640 ){
							return;
						}
						var maxWidth = $(mainFormId).width();
						var halfWidth = maxWidth / 2;
						$(metadataContent).find('.inner-section').each(function(){
							$(this).removeClass('span_half');
							$(this).removeClass('span_full');
							$(this).addClass('span_full');
							var labelWidth = $(this).find('label').width();
							var inputWidth = $(this).find('.input').width();
							var width = Math.max(labelWidth, inputWidth);
							if( width < halfWidth){
								$(this).removeClass('span_full');
								$(this).addClass('span_half');
							}
						});

						var descElem = $(mainFormId + ' #job-step-1 #description');
						var endX = descElem.position().top + descElem.height();
						var maxX = $(mainFormId + ' #job-step-1').height();
						if( endX > maxX ){
							var dif = endX - maxX;
							descElem.height( descElem.height() - dif );
						}else{
							descElem.css('height', 'auto');
						}
					}

			        function validateStep2() {
			        	var valid = true;

			        	$(stepIdPrefix + '2 :input').each(function(index,value){
			        		var type = $(value).attr('type');
			        		if(type != 'button' && type != 'submit' && ! $(this).attr('disabled') ) {
			        			var elvalid = $(value.form).validate().element($(value));
			        			valid &= elvalid;
			        			if(!elvalid){
			        				value.focus();
			        			}
			        		}
			        	});

			        	return valid;
			        }

					function validateStep3() {
			        	var valid = true;

			        	return valid;
			        }

			        function validateRegistration() {
			        	var valid = $('#registration-form').valid();
			        	return valid;
			        }

			        function validateLogin() {
			        	var valid = true;
			        	$('#login-form :input').filter(":visible").each(function(index,value){
			        		var elvalid = $('#login-form').validate().element($(value));
			        		valid &= elvalid;
			        		if(!elvalid){
		        				value.focus();
		        			}
			        	});

			        	return valid;
			        }

			        var globalShowStep1 = globalShowStep2 = globalShowStep3 = 0;

			        this.showStep1 = function(showMetadata) {
			        	$(metadataStringyId).val('');
			        	if(showMetadata){
							loadMetadata();
						}
			        	$(stepIdPrefix + "2").hide();
			        	$(stepIdPrefix + "3").hide();
			        	$(stepIdPrefix + "1").show();

			        	$('#create-job-container .nav .' + nextStepClass ).show();
			        	$('#create-job-container .nav .' + prevStepClass ).hide();
			        	$("#job-tab-1").attr("class","tab-on text-m bold");
			        	$("#job-tab-2").attr("class","tab-off text-m bold");
			        	$("#job-tab-3").attr("class","tab-off text-m bold");

			        	$('#job-step-title .step-1').show();
			        	$('#job-step-title .step-2').hide();
			        	$('#job-step-title .step-3').hide();

			        	arrangeMetadataStyles();

			        	scrollToTop();

			        	Marb.Commons.Track.event('create-job','show-step-1', globalShowStep1++);
			        }

			        this.showStep2 = function(showMetadata) {
			        	if( ! $(metadataStringyId).val() ){
			        		var metadataForm = $("<form></form>");
			        		metadataForm.append($(metadataContent).clone());
			        		$(metadataStringyId).val($(metadataForm).serialize());
			        	}

		        		//get suggested product installations
			        	$('#suggestion-link #suggestedProductInstallation').val(0);
		        		$.post('/job/installation/suggested',
		        			{
		        				metadata: $(metadataStringyId).val(),
		        				subcatId: $(subCategoryComboId).val()
		        			},
		        			function(response){
		        				if( response.success ){
		        					var prefix = mainFormId + ' ' + stepIdPrefix + '2 ';
		        					if( response.data.suggestionAvailable ){
		        						Marb.Commons.Track.event('job','suggestion','shown');

		        						var product = response.data.product;
		        						$('#suggestion-link #suggestedProductInstallation').val(product.productId);
		        						if( suggestedProductCallback == null ){
		        							$(prefix + ' #suggestion-link').unbind('click');
		        							$(prefix + ' #suggestion-link').on('click', function(){
		        								checkClassifiedsInLocation(function() {
		        									Marb.Commons.Track.event('job', 'suggestion', 'click');
		        									var frm = $('#create-job-form').clone();
		        									var postAction = product.link;
		        									if( ! postAction.startsWith("/") ){
		        										postAction = "/" + postAction;
		        									}
		        									frm.attr('action', postAction);
		        									//marker attribute
		        									frm.append( $('<input type="hidden" name="fromJobWizard" value="1" />') );
		        									frm.submit();
		        								});
		        							});
		        							$(prefix + ' .hire-now .desc').text(product.name);
		        							$(prefix + ' .price .value .amount').text(product.price);
		        							if( product.showAmount ){
		        								$(prefix + ' .price .value .desc').show();
		        							}else{
		        								$(prefix + ' .price .value .desc').hide();
		        							}
		        							$(prefix + ' .price .value .desc .unit').text(product.units);
		        							
		        							$(prefix).addClass('has-installation');
		        							$(prefix + ' #suggestion-link').show();
		        						}else{
		        							suggestedProductCallback(product);
		        						}
		        					}else{
		        						$(prefix).removeClass('has-installation');
		        						$(prefix + ' #suggestion-link').hide();
		        						Marb.Commons.Track.event('job','suggestion','none');
		        					}
		        				}else{
		        					Marb.Commons.Track.event('job','suggestion','error');
		        				}
		        			}
		        		);

						if(showMetadata){
							loadMetadata();
						}
						$(stepIdPrefix + "1").hide();
			       		$(stepIdPrefix + "2").show();
			       		$(stepIdPrefix + "3").hide();

			       		$("#job-tab-1").attr("class","tab-off text-m bold");
			        	$("#job-tab-2").attr("class","tab-on text-m bold");
			        	$("#job-tab-3").attr("class","tab-off text-m bold");

			        	$('#create-job-container .nav .' + nextStepClass ).hide();
			        	$('#create-job-container .nav .' + prevStepClass ).show();

			        	$('#job-step-title .step-1').hide();
			        	$('#job-step-title .step-2').show();
			        	$('#job-step-title .step-3').hide();

			        	$('#create-job-container .prevstep').data('prevstep', 1);

			        	scrollToTop();

			        	//force radio check behavior
			        	$(mainFormId  + ' #job-step-2 input[type=radio]:checked').click();
			        	Marb.Commons.Track.event('create-job','show-step-2', globalShowStep2++);
			        }

			        this.showStep3 = function(showMetadata) {

						//if already logged-in do not show 3rd step.
						if( $('#create-job-container ' + isLoggedId).val() == 'true' ){
							doSubmitForm();
							return;
						}

						$('#create-job-container .show-login').show();
						$('#create-job-container .show-registration').hide();
						
						if ($('#userPhone').val() != ''){
							$('.col.span_6_12.phone').hide();
							$('#phone').val($('#userPhone').val());
						}else{
							$('#phone').val('');
							$('.col.span_6_12.phone').show();
						}

						$(stepIdPrefix + "1").hide();
						$(stepIdPrefix + "2").hide();
			       		$(stepIdPrefix + "3").show();

			       		$("#job-tab-1").attr("class","tab-off text-m bold");
			        	$("#job-tab-2").attr("class","tab-off text-m bold");
			        	$("#job-tab-3").attr("class","tab-on text-m bold");

			        	$('#job-step-title .step-1').hide();
			        	$('#job-step-title .step-2').hide();
			        	$('#job-step-title .step-3').show();

			        	$('#create-job-container .nav .nextstep').hide();
			        	$('#create-job-container .prevstep').data('prevstep', 2);

			        	scrollToTop();

			        	Marb.Commons.Track.event('create-job','show-step-3', globalShowStep3++);
			        }

			        function scrollToTop(){
			        	if( $(window).width() < 640 && $(window).scrollTop() > $('#create-job-container').offset().top){
			        		Marb.Commons.Utils.scrollToTop('#create-job-container');
			        	}
			        }
			        
			        function doSubmitForm(){
			        	var description = $(stepIdPrefix + '1 #description');
			        	Marb.Commons.Track.event('create-job','finished');
			        	$(mainFormId).submit();
			        }

			        function ready() {
			        	// coming back from facebook after creating a job
			        	if(window.location.hash == '#_=_') {
			        		Marb.Loader.block();
			        	}
			        	// if the user left a previous form in progress
			        	else if(workInProgress &&  window.location.href.indexOf('msgCode=') == -1 ) {
			        		Marb.Components.Confirm.openSimple({
			    				title: $.i18n.prop('p.createjob.reset.title'),
			    				body: $.i18n.prop('p.createjob.reset.body'),
			    				cancelText: $.i18n.prop('p.createjob.reset.accept'),
			    				acceptText: $.i18n.prop('p.createjob.reset.cancel'),
			    				accept: function(){			    						
			    					$.post("/job/reset",function(data) {
			    						location.href = location.href;			    						
			    					});
			    				},
			    				cancel: function(){
			    					$('.tab-header.quotes').click();		    					
			    				},
			    			});
			        	}
			        	//if the user selected a pro from the list
			        	else if (fromCompanyReferrer){
			        		showReferrerPopup();
			        	}

			        	var step = $(stepId).val();

			        	showSteps[step-1](true);

			        	$.validator.messages.required = "";
			        	$.validator.messages.latinDate = "";
			        	$.validator.messages.min = "";
			        	$.validator.messages.max = "";
			        	$.validator.messages.email = "";
			        	$.validator.messages.equalTo = "";

			        	jQuery.validator.addMethod(
		        		    "otherInputNotEmpty",
		        		    function(value,element,params) {
		        		    	if( ! $(params).val() ){
		        		    		return false;
		        		    	}
		        		        return true;
		        		    },
		        		    ""
		        		);

			        	$('#job-step-2 input').each(function(){
							$(this).watermark( $(this).data('wmark') );
						});
			        	$('#job-step-3 #registration-form input').each(function(){
							$(this).watermark( $(this).data('wmark') );
						});
						$('#registration-form').validate({
							rules: {
								"customerRegistrationForm.username": {
			        				required: true,
			        				email: true,
			        				remote: {
			    						url: "/email-check",
			    						type: "get",
			    						data: {
								          username: function() {
								            return $("#registration-username").val();
								          }
								        }
			    					}
			        			},
			        			"customerRegistrationForm.firstname": {
			        				required: true
			        			},
			        			"customerRegistrationForm.lastname": {
			        				required: true
			        			},
			        			"customerRegistrationForm.phone": {
			        				required: true
			        			},
			        			"customerRegistrationForm.password": {
			        				required: true,
			        				minlength: 4
			        			}
							},
							messages: {
			    				"customerRegistrationForm.username": {
			    					remote: $("#validation-email-alreadyExists").data("value"),
			    					email: $("#validation-email-invalid").data("value")
			    				},
			    				"customerRegistrationForm.password": {
			    					minlength: $.i18n.prop('p.createuser.msg.fields.password')
			    				}
			    			},
			        		errorPlacement : function(error,element){
			    				error.addClass("custom-error");
			    				var container = $('#create-job-container #form-error-container');
			    				container.append(error);
			    			},
			    			errorElement: "span"
						});

						$('#login-form').validate({
							rules: {
								"j_username": {
			        				required: true,
			        				email: true
			        			},
			        			"j_password": {
			        				required: true
			        			}
							},

			        		errorPlacement : function(error,element){
			    				error.addClass("custom-error");
			    				error.insertAfter( element.next() );
			    			},
			    			errorElement: "div"
						});

			        	$(mainFormId).validate({
			        		rules: {
			        			categoryId: {
			        				required : true
			        			},
			        			subCategoryId: {
			        				required : true
			        			},
			        			title: {
			        				required : true
			        			},
			        			timeFrame: {
			        				required : true
			        			},
			        			city: {
			        				required: true
			        			},
			        			"when": {
			        				required: true,
			        				latinDate: true
			        			},
			        			"whenTimeFrom": {
			        				required: true,
			        				min:1,
			        				max:24
			        			},
			        			"whenTimeTo": {
			        				required: true,
			        				min:1,
			        				max:24
			        			},
			        			"whenAlternative": {
			        				required: true,
			        				latinDate: true
			        			},
			        			"whenAlternativeTimeFrom": {
			        				required: true,
			        				min:1,
			        				max:24
			        			},
			        			"whenAlternativeTimeTo": {
			        				required: true,
			        				min:0,
			        				max:23
			        			},
			        			"citytxt": {
			        				"otherInputNotEmpty": "#city"
			        			}
			        		},
			        		messages: {
			    				"customerRegistrationForm.username": {
			    					remote: $("#validation-email-alreadyExists").data("value"),
			    					required: $("#validation-email-invalid").data("value")
			    				},
			    			},
			        		errorPlacement : function(error,element){
			    				error.addClass("custom-error");
			    				error.insertAfter( element );
			    			},
			    			errorElement: "div"
			        	});

			        	jQuery.validator.addMethod("greaterEquals",
			          			function(value, element, params) {
			          			    return isNaN(value) && isNaN($(params).val())
			          			        || (Number(value) > Number($(params).val()));
			          			},'');

			        	if( validateAutocomplete ){
			        		Marb.Geo.validateAutocomplete("city-search-text","city","");
			        	}

			        	if(window.location.hash == '#_=_') {
			        		doSubmitForm();
			        	}

			        }

			        function takeSnapshot(callback){
			        	callback = callback || function(){};

			        	$.post("/job/snapshot", $(mainFormId).serialize(), callback);
			        }

			        function showReferrerPopup() {
			        	Marb.Components.Confirm.openSimple({
							title: $('.referrer-title').text(),
							bodyHtml: $('.referrer-text').html(),
							showCancel: false
						});
			        }

			        var validators = [validateStep1,validateStep2,validateStep3];
			        var showSteps = [this.showStep1,this.showStep2,this.showStep3];

			        ready();
				}
			};

			return {
				cancelJob : cancelJob,
				acceptQuote : acceptQuote,
				cancelQuote : cancelQuote,
				acceptQuoteVisit : acceptQuoteVisit,
				rateValue : rateValue,
				rateValueValidate : rateValueValidate,
				rateJob : rateJob,
				viewJobRating: viewJobRating,
				markJobFinished: markJobFinished,
				JobWizard : JobWizard,
				filterDashboard : filterDashboard,
				viewJobDetails : viewJobDetails
			};
		})()
	});

}
catch (e) {
	debug.error("Marb namespace not present", e);
}
